import { InjectionToken } from '@angular/core';

export const SN_APPBAR_ACTIONS_DATA = new InjectionToken('SN_APPBAR_ACTIONS_DATA');
